import * as React from 'react';
import styles from './favourite-info.scss';

interface FavouriteInfoComponentProps {
  id?: number;
  invalidOwners?: number[];
  owners?: { value: number; description: string }[];
  parent?: string;
}

export const FavouriteInfo: React.FC<FavouriteInfoComponentProps> = ({
  id, invalidOwners, owners, parent
}) => (
  <div className={styles.tileInfo}>
    <ul className={styles.tileInfoContent}>
      {!!id && <li className={styles.tileId}>#{id}</li>}
      {!!owners && owners.map((owner, index) =>
        <li key={index} className={invalidOwners?.includes(owner.value) ? styles.invalidOwner : undefined}>
          <span className="default-icon user" />{owner.description}
        </li>)}
      {!!parent && <li><span className="default-icon folder-small" />{parent}</li>}
    </ul>
  </div>
);
